/* Material feedback only. Existing Shopify purchase handlers retain ownership. */
(()=>{'use strict';
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 function pulse(el,name){if(!el||reduced.matches)return;el.classList.remove(name);requestAnimationFrame(()=>{el.classList.add(name);setTimeout(()=>el.classList.remove(name),300);});}
 document.addEventListener('click',event=>{
  const button=event.target.closest('.az-os-btn,.az-os-controls button,.az-os-gallery__nav button,.azmc-btn');
  if(button&&document.querySelector('.az-house-pdp')&&!button.disabled)pulse(button,'az-house-pressed');
 });
 document.addEventListener('change',event=>{
  if(event.target.matches('.az-os-qty input'))pulse(event.target,'az-house-counted');
 });
})();
